<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'PRODUCTS', pageCode: 'ALL', subPageCode: 'ADD' }">
  <app-module-header [label]="btnLabel" [showImportExportBtn]="showImportExportBtn" (onBtnClick)="onAddProduct()" [showLastSync]="false"></app-module-header>
</div>
<div appAccessProvider [accessCode]="{ menuCode: 'PRODUCTS', pageCode: 'ALL', subPageCode: 'LIST' }">
<p-tabView [(activeIndex)]="activeIndex" (onChange)="tabViewChange($event)" [scrollable]="true">
  <p-tabPanel>
    <ng-template pTemplate="header">
      <i class="{{miIcons.DASHBOARD_ACTIVITY_FEED}} inline-block wh-14 mr-2 relative"></i>
      <span [ngClass]="{'active-tab-label': activeIndex === 0, 'inactive-tab-label': activeIndex !== 0}" class="tab-label" translate>lbl_all</span>&nbsp;<span class="iconNumber text-color-secondary">({{entityCount?.counts?.ALL}})</span>
    </ng-template>
    <ng-template pTemplate="body">
      @if(data){
        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="product"
          [isLoading]="isLoading"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [totalRecords]="totalRecords"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteProductMsg"
          [header]="deleteProductHeaderMsg"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          (onValueChange)="onFilterValueChange($event)"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddProduct()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          (onUpdate)="onUpdateVehicle($event)"
          [rowItems]="rowItems"
          [bulkSelectionsItems] = "bulkSelectionsItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          [visible]="visible"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          (onSortData)="onSortData($event)"          
          [isEntity]="isEntity"
          (onDelete)="onVehicleDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          >
        </app-mi-table>
      }
    </ng-template>
  </p-tabPanel>

  <p-tabPanel>
    <ng-template pTemplate="header">
      <i class="{{miIcons.ARCHIVE_PRODUCTS}} inline-block wh-16 mr-2 relative"></i>
      <span [ngClass]="{'active-tab-label': activeIndex === 1, 'inactive-tab-label': activeIndex !== 1}" class="tab-label" translate>product.lbl_archive</span>&nbsp;<span class="iconNumber text-color-secondary">({{entityCount?.counts?.ARCHIVE}})</span>
    </ng-template>
    <ng-template pTemplate="body">
       <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="product"
          [isLoading]="isLoading"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [totalRecords]="totalRecords"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteProductMsg"
          [header]="deleteProductHeaderMsg"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          (onValueChange)="onFilterValueChange($event)"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddProduct()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          (onUpdate)="onUpdateVehicle($event)"
          [rowItems]="rowItems"
          [bulkSelectionsItems] = "bulkSelectionsItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          [visible]="visible"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          (onSortData)="onSortData($event)"          
          [isEntity]="isEntity"
          (onDelete)="onVehicleDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          >
        </app-mi-table>
    </ng-template>
  </p-tabPanel>

  <p-tabPanel>
    <ng-template pTemplate="header">
      <i class="{{miIcons.BASIC_TRAY}} inline-block wh-16 mr-2 relative"></i>
      <span [ngClass]="{'active-tab-label': activeIndex === 2, 'inactive-tab-label': activeIndex !== 2}" class="tab-label" translate>product.lbl_deleted</span>&nbsp;<span class="iconNumber text-color-secondary">({{entityCount?.counts?.DELETED}})</span>
    </ng-template>
    <ng-template pTemplate="body">
      <!-- @if (listColumns) { -->
        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="product"
          [isLoading]="isLoading"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [totalRecords]="totalRecords"    
          [itemsPerPage]="itemsPerPage"
          [message]="deleteProductMsg"
          [header]="deleteProductHeaderMsg"
          (onDelete)="onVehicleDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddProduct()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          (onValueChange)="onFilterValueChange($event)"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          (onUpdate)="onUpdateVehicle($event)"
          [rowItems]="rowItems"
          [bulkSelectionsItems] = "bulkSelectionsItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          [visible]="visible"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          (onSortData)="onSortData($event)"          
          [isEntity]="isEntity"
          >
        </app-mi-table>
      <!-- } -->
    </ng-template>
  </p-tabPanel>


</p-tabView>
</div>
<p-toast></p-toast>
<input hidden type="file" id="upload" (change)="onChange($event)" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" #uploader>